<template>
  <div class="view-leads">
    <div class="header mb-6">
      <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
        @click="goBack()"></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t("labels.vessel_detail") }}</h2>
      </div>
      <div class="history w-1/2 justify-right">
        <vs-button v-if="!isUserType('CL')" color="dark" type="filled" icon-pack="feather" icon="icon-activity" @click="
          $router.push({ name: 'History', params: { id: id, model: model } })
          " class="float-right">{{ $t("labels.history") }}</vs-button>
      </div>
    </div>

    <div class="view-lead">
      <vx-card class="vessel-details" :title="$t('labels.vessel')">
        <div class="vx-row mb-4">
          <div class="vx-col w-full mb-4">
            <div class="vx-row w-full mt-4 m-0">
              <div class="vx-col sm: w-full md:w-1/2">
                <div class="vx-row mb-0">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.name") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ name ? name : "-" }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
                <div class="vx-row">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.imo_number") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ imo_number ? imo_number : "-" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full mt-4 m-0">
              <div class="vx-col sm: w-full md:w-1/2">
                <div class="vx-row mb-0">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.owner") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <router-link class="view-link" :to="{
                      name: 'ViewUser',
                      params: { id: vessel.owner_id },
                    }" v-if="checkPermission('user', 'view') || vessel">
                      <span>{{ owner ? owner : "-" }}</span></router-link>
                  </div>
                </div>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
                <div class="vx-row">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.manager") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <router-link class="view-link" :to="{
                      name: 'ViewUser',
                      params: { id: vessel.manager_id },
                    }" v-if="checkPermission('user', 'view') || vessel">
                      <span>{{ manager ? manager : "-" }}</span></router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full mt-4 m-0">
              <div class="vx-col sm: w-full md:w-1/2">
                <div class="vx-row mb-0">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.office") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <router-link class="view-link" :to="{
                      name: 'ViewUser',
                      params: { id: vessel.office_id },
                    }" v-if="checkPermission('user', 'view') || vessel">
                      <span>{{ office }}</span></router-link>
                  </div>
                </div>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
                <div class="vx-row">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.fleet") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <router-link class="view-link" :to="{
                      name: 'ViewUser',
                      params: { id: vessel.fleet_id },
                    }" v-if="checkPermission('user', 'view') || vessel">
                      <span>{{ fleet }}</span></router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full mt-4 m-0">
              <div class="vx-col sm: w-full md:w-1/2">
                <div class="vx-row mb-0">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.type") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ type }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
                <div class="vx-row">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.subtype") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ subtype }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full mt-4 m-0">
              <div class="vx-col sm: w-full md:w-1/2">
                <div class="vx-row mb-0">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.flag") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ country }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0">
                <div class="vx-row">
                  <div class="vx-col sm: w-1/2">
                    <label>{{ $t("labels.port") }}:</label>
                  </div>
                  <div class="vx-col sm: w-1/2">
                    <span>{{ port }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <project v-if="vessel" class="mt-8" :vessel-id="vessel.id"></project>
  </div>
</template>
<script>
import Project from "@/views/projects/listing";

export default {
  components: {
    Project,
  },
  data() {
    return {
      vessel: null,
      parent_id: null,
      name: "",
      owner: null,
      manager: null,
      office: null,
      fleet: null,
      type: null,
      subtype: null,
      is_active: null,
      imo_number: null,
      port: null,
      country: null,
      model: "vessel",
      id: this.$route.params.id,
    };
  },
  computed: {},
  mounted() {
    this.getVessels();
  },
  methods: {
    async getVessels() {
      let response = await this.getHTTPGetResponse(
        "/vessels/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let vessel = data.vessel;
        this.vessel = vessel;
        this.subtype = vessel.sub_type.name;
        this.country = vessel.flag.name;
        this.port = vessel.port.name;
        this.name = vessel.name;
        this.is_active = vessel.is_active;
        this.type = vessel.type.name;
        this.imo_number = vessel.imo_number;
        if (!vessel) return;
        this.owner = vessel.owner.name;
        this.manager = vessel.manager.name;
        this.office = vessel.office.name;
        this.fleet = vessel.fleet.name;
      }
    },
    goBack() {
      history.back();
    },
  },
};
</script>
<style scoped>
label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
</style>
